// 就多了一个getContainer默认值
import { ResultMessage, ResultMessageProps } from "components/ResultMessage";

function getContainer() {
    return document.querySelector(".PopupContainer") as any;
}

export default {
    success: (text: string, props?: ResultMessageProps) =>
        ResultMessage.success(text, { ...props, getContainer }),
    error: (text: string, props?: ResultMessageProps) =>
        ResultMessage.error(text, { ...props, getContainer })
};
